import { CircleUser } from "lucide-react";
import { useSession } from "@clerk/nextjs";
import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar";
import PersonalAccountIcon from "./personal-account-icon";

const UserButton = ({ className }: { className?: string }) => {
  const { session, isSignedIn } = useSession();

  return (
    <div>
      {isSignedIn ? (
        <PersonalAccountIcon className={className} />
      ) : (
        <CircleUser />
      )}
    </div>
  );
};

export default UserButton;
